import './GuardianOfZone.css';

export default function SubconcienciaGuardian() {
  return (
    <svg className="guardian-svg guardian-subconciencia" viewBox="0 0 100 150" role="img">
      <title>Subconciencia — La Sombra, agazapada y disolviéndose en fragmentos</title>
      <g transform="rotate(-9 55 30)">
        <path d="M45 12 C36 12 31 20 32 30 C33 35 37 38 45 38 C53 38 57 35 58 30 C59 20 54 12 45 12 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.3" opacity="0.9" />
        <ellipse cx="45" cy="27" rx="6.5" ry="8" className="g-cutout" />
        <circle cx="43" cy="27" r="0.8" className="g-fill-core" />
        <circle cx="47" cy="28" r="1.1" className="g-fill-core" />
      </g>
      <path d="M52 40 C68 44 78 54 80 66 C70 68 58 66 52 60 C46 56 46 46 52 40 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.3" opacity="0.85" />
      <path d="M35 46 C24 52 16 66 14 84 C22 88 32 86 40 78 C44 68 44 54 35 46 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.3" opacity="0.88" />
      <path d="M18 84 C14 92 12 102 16 110" fill="none" className="g-stroke-b" strokeWidth="6" strokeLinecap="round" opacity="0.85" />
      <circle cx="17" cy="112" r="4" className="g-fill-b g-stroke-bg" strokeWidth="1.2" />
      <g opacity="0.85">
        <polygon points="42,80 54,78 50,96 38,98" className="g-fill-b g-stroke-bg" strokeWidth="1.1" />
        <polygon points="56,82 68,84 64,102 52,100" className="g-fill-b g-stroke-bg" strokeWidth="1.1" />
      </g>
      <g className="g-drift" opacity="0.6">
        <polygon points="30,104 38,102 34,114 26,116" className="g-fill-b g-stroke-bg" strokeWidth="1" />
        <polygon points="58,108 66,110 60,122 52,120" className="g-fill-b g-stroke-bg" strokeWidth="1" />
        <polygon points="44,120 50,124 42,132" className="g-fill-b" />
      </g>
      <g opacity="0.4">
        <polygon points="20,120 26,124 18,130" className="g-fill-b" />
        <polygon points="72,96 78,100 70,104" className="g-fill-b" />
      </g>
    </svg>
  );
}
